<template>
  <section class="video-news-area">
    <div class="container custom-container">
      <div
        :class="[
          'video-news-box',
          darkClass && 'section' in darkClass ? darkClass.section : '',
        ]"
      >
        <div class="row">
          <div class="col-lg-8">
            <div class="video-news-post">
              <div class="section-title section-title-2">
                <h3 class="title">市场洞察</h3>
              </div>
              <div
                v-if="smallPostGallery.length"
                :class="[
                  'video-news-post-item',
                  darkClass && 'section_2' in darkClass
                    ? darkClass.section_2
                    : '',
                ]"
              >
                <div class="video-news-post-thumb custom-bg"
                :style="{ backgroundImage: `url(${smallPostGallery[0].coverurl})` }" 
                >
                  <!--
                  <div class="play-btn">
                    <a
                      class="video-popup"
                      @click.prevent="$store.dispatch('toggleVideo')"
                      ><i class="fab fa-youtube"></i
                    ></a>
                  </div>
                  -->
                </div>
                <div class="video-news-post-content">
                  <div class="post-meta">
                    <div class="meta-categories">
                      <router-link :to="`/articles/${smallPostGallery[0].id}`">{{ smallPostGallery[0].channel }}</router-link>
                    </div>
                    <div class="meta-date">
                      <span>{{ smallPostGallery[0].createdat }}</span>
                    </div>
                  </div>
                  <h3 class="title">
                    <router-link :to="`/articles/${smallPostGallery[0].id}`">
                      {{ smallPostGallery[0].title }}
                    </router-link>
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="populer-post">
              <div class="section-title">
                <h3 class="title">推荐</h3>
              </div>
              <div class="trending-sidebar-slider position-relative">
                <span
                  @click="tssPrev"
                  class="prev slick-arrow"
                  style="display: block"><i class="fal fa-angle-left"></i>
                </span>
                <slider v-if="smallPostGallery.length" :settings="videoNewsSlide" ref="trendingSidebarSlide">
                  <div class="post_gallery_items">
                    <template
                      v-for="(small, index) in smallPostGallery.slice(1, 5)"
                    >
                      <row-card
                        :class="[
                          'populer_item-style',
                          darkClass && 'news_item' in darkClass
                            ? darkClass.news_item
                            : '',
                        ]"
                        :key="index"
                        :trending="true"
                        :datas="small"
                      />
                    </template>
                  </div>
                  <div class="post_gallery_items">
                    <template
                      v-for="(small, index) in smallPostGallery.slice(5, 9)"
                    >
                      <row-card
                        :class="[
                          'populer_item-style',
                          darkClass && 'news_item' in darkClass
                            ? darkClass.news_item
                            : '',
                        ]"
                        :key="index"
                        :trending="true"
                        :datas="small"
                      />
                    </template>
                  </div>
                </slider>
                <span
                  @click="tssNext"
                  class="next slick-arrow"
                  style="display: block"
                  ><i class="fal fa-angle-right"></i
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Slider from "../Helpers/Slider.vue";
import RowCard from "../Utility/Cards/RowCard.vue";
export default {
  components: { Slider, RowCard },
  props: {
    darkClass: {
      type: Object,
    },
  },
  inject: ['dataWrapper', 'fetchStatus'],
  data: () => ({
    smallPostGallery: [],
    videoNewsSlide: {
      arrows: false,
      slidesToShow: 1,
      slideToScroll: 1,
    },
  }),
  watch: {
    'fetchStatus.isFetched': {
      handler(newVal) {
        if (newVal) {
          this.smallPostGallery = Array.isArray(this.dataWrapper.articles) 
            ? this.dataWrapper.articles.filter(item => item.orgchannel === '1').slice(0, 10) 
            : [];
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    tssPrev() {
      this.$refs.trendingSidebarSlide.prev();
    },
    tssNext() {
      this.$refs.trendingSidebarSlide.next();
    },
  },
};
</script>

<style scoped>
.custom-bg {
  background-size: cover;
  background-position: center;
  /* 默认宽度和高度，适用于大屏幕 */
  width: 100%;
  height: 388px;
}

/* 中等屏幕，例如平板电脑 */
@media (max-width: 992px) {
  .custom-bg {
    width: 100%;
    height: 300px;
  }
}

.populer-post {
  /* 桌面端默认左边距，可根据实际情况调整 */
  margin-left: 0;
}

/* 小屏幕，例如手机 */
@media (max-width: 768px) {
  .populer-post {
    /* 手机端添加左边距，可根据实际需求调整 */
    margin-left: 15px; 
  }
}

/* 超小屏幕 */
@media (max-width: 576px) {
  .populer-post {
    /* 超小屏幕添加左边距，可根据实际需求调整 */
    margin-left: 10px; 
  }
}
</style>